import appConstant from "common/constants/appConstant";
import ROUTE_CONSTANTS from "common/constants/route";
import QuotingWidgetApp from "components";
import ConversationalForm from "components/conversationalForm";
import Quote from "components/QuoteContainer";
import MyPetForm from "components/QuotingForm";
import Error from "../components/error";

const appRoutes = [
    {
        path: ROUTE_CONSTANTS.ROOT,
        component: QuotingWidgetApp,
        exact: true,
        type: appConstant.ROUTE_TYPES.PUBLIC,
    },
    {
        path: ROUTE_CONSTANTS.PET_FORM,
        component: MyPetForm,
        exact: true,
        type: appConstant.ROUTE_TYPES.PUBLIC,
    },
    {
        path: ROUTE_CONSTANTS.QUOTE,
        component: Quote,
        exact: true,
        type: appConstant.ROUTE_TYPES.PUBLIC,
    },
    {
        path: ROUTE_CONSTANTS.CONVERSATIONAL_FORM,
        component: ConversationalForm,
        exact: true,
        type: appConstant.ROUTE_TYPES.PUBLIC,
    },
    {
        path: ROUTE_CONSTANTS.ERROR,
        component: Error,
        exact: true,
        type: appConstant.ROUTE_TYPES.PUBLIC,
    },
];

export default appRoutes;
